/*
 * File Created: Wednesday, 4th January 2023 12:34:22 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Box, Divider, Theme, useTheme } from '@mui/material';
import React  from 'react';
import Header from '../components/head/Header';
import ScrollToTop from '../components/scroll_to_top/ScrollToTop';
import { staticData } from "../data/staticData";
import SocialAndReview from '../components/social_and_review/SocialAndReview';
import Section from "../components/Skeleton/Section.skeleton";
// import VideoBanner from "../components/video_banner/VideoBanner";
import Footer from "../components/footer/Footer";

const Content = React.lazy(
  () => import('../components/slide/Content')
);

function Home(): JSX.Element {
  const theme: Theme = useTheme();
  const contents: Array<JSX.Element> = staticData.sections.map((data, index) => {
    console.log("HOME : STATIC DATA : ", data)
    return (
      <React.Suspense
        key={data.id}
        fallback={
          <Section
            reverse={parseInt(data.id, 10) % 2 ? false : true}
            id={data.id}
          />
        }
      >
        <Content
          reverse={parseInt(data.id, 10) % 2 ? false : true}
          description={data.description}
          banner={data.banner}
          id={(index).toString()}
          title={data.title}
          items={data.items}
        />
        {/* <VideoBanner id={index} /> */}
      </React.Suspense>
    )
  })

  return (
    <React.Fragment>
      <Header />
      {contents}
      <SocialAndReview />
      <Divider flexItem orientation='horizontal' />
      <Footer />
      <Box
        sx={{
          position: 'fixed',
          right: { xs: theme.spacing(5), md: theme.spacing(7.5), lg: theme.spacing(10) },
          bottom: { xs: theme.spacing(20), md: theme.spacing(7.5), lg: theme.spacing(10) },
          zIndex: theme.zIndex.snackbar,
        }}
      >
        <ScrollToTop />
      </Box>
    </React.Fragment>
  );
};

export default Home;
